import AppRoute from "models/AppRoute"

const DashboardRoute = new AppRoute({
    route: "/",
    navbar: true,
    authRequired: true,
})

export default DashboardRoute
